
export const mapBuckets = (bucket:any) => {
    const date = new Date(bucket.bucket)
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0') // Months are zero-based
    const year = date.getFullYear()
    const hour = date.getHours().toString().padStart(2, '0')
    const minute = date.getMinutes().toString().padStart(2, '0')
    return `${day}.${month}.${year} ${hour}:${minute}`
}